import React, { useEffect, useState } from 'react';

/**
 * Renders children only after mount, keeping them out of the server HTML.
 *
 * Password managers add an icon element next to the fields they recognize —
 * on load for sign-in forms, on focus for registration ones. A node injected
 * into server-rendered markup before hydration finishes breaks hydration
 * (React #418/#423, DP-2190). Mounting afterwards lets the extension attach
 * once React is done, which it handles without complaint.
 *
 * `placeholderClassName` holds the subtree's footprint so the rest of the page
 * doesn't shift when the children appear.
 */
const ClientOnly = (props: {
  children: React.ReactNode;
  placeholderClassName?: string;
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className={props.placeholderClassName} aria-hidden="true" />;
  }

  return <>{props.children}</>;
};

export default ClientOnly;
